module.exports = __webpack_public_path__ + "static/media/img-home5.0dcd36d9.jpg";